/**
 * These endpoints are very inconsistent and the data is not always
 * returned as expected. We cover it with try catches, fallback values and
 * tests.
 */
import { get } from 'lib/request';

export const getActiveAdsByStore = async ({ storeSlug }) => {
  try {
    const {
      data: {
        storeAd: [storeAd = getActiveAdsByStore.fallback],
      },
    } = await get(`/ads/store/${storeSlug}`);

    return storeAd;
  } catch {
    return getActiveAdsByStore.fallback;
  }
};

getActiveAdsByStore.fallback = null;

export const getAds = async ({ type } = {}, opts) => {
  try {
    return await get(`/ads${type ? `?type=${type}` : ''}`, opts);
  } catch {
    return getAds.fallback;
  }
};

getAds.fallback = {
  data: {
    cardAd: [],
    sidebarAd: [],
    smallAd: [],
    storeFullAd: [],
    topAd: [],
    topbarHighlight: [],
  },
};

export const getNavbarAds = async (opts) => {
  try {
    const {
      data: { topbarHighlight },
    } = await getAds({ type: 'TOPBAR_HIGHLIGHT' }, opts);

    return topbarHighlight;
  } catch {
    return getNavbarAds.fallback;
  }
};

getNavbarAds.fallback = [];

export const getTopbarAd = async (opts) => {
  try {
    const {
      data: {
        topAd: [topbarAd = getTopbarAd.fallback],
      },
    } = await getAds({ type: 'TOP_AD' }, opts);

    return topbarAd;
  } catch {
    return getTopbarAd.fallback;
  }
};

getTopbarAd.fallback = {
  bgcolor: [],
  description: null,
  image: null,
  mobileImage: null,
  url: null,
};

export const getSearchAd = async (opts) => {
  try {
    const {
      data: { sponsorAd = getSearchAd.fallback },
    } = await getAds({ type: 'SPONSOR_AD' }, opts);

    return sponsorAd;
  } catch {
    return getSearchAd.fallback;
  }
};

getSearchAd.fallback = [];
